var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("timeline-item-card", {
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("checklist-component", {
              attrs: {
                title: _vm.title,
                checklist: _vm.checklist,
                "edit-title": _vm.editingTitle,
              },
              on: { input: _vm.handleUpdate },
            }),
            _vm._v(" "),
            _vm.editingTitle
              ? _c(
                  "b-button",
                  {
                    staticClass: "float-right mb-2",
                    attrs: { variant: "primary", size: "sm" },
                    on: { click: _vm.handleEditChecklist },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("client-profile.actions.saveChecklist")) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("timeline-card-footer", {
              attrs: { pinned: _vm.pinned },
              on: {
                pinned: function ($event) {
                  return _vm.handlePin(_vm.id, _vm.activityType, _vm.pinned)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "left",
                  fn: function () {
                    return [
                      _c(
                        "b-col",
                        {
                          staticClass: "vertical-center mb-md-0 mb-2",
                          attrs: { cols: "12", md: "auto" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "vertical-center" },
                            [
                              _c(
                                "profile-avatar",
                                _vm._b(
                                  {
                                    staticClass:
                                      "client-profile-owner-avatar mr-2",
                                    attrs: {
                                      "avatar-options": { inline: true },
                                    },
                                  },
                                  "profile-avatar",
                                  Object.assign({}, _vm.creator),
                                  false
                                )
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "mr-1" }, [
                                _vm._v(_vm._s(_vm.name)),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("i18n", {
                            staticClass: "text-lowercase",
                            attrs: {
                              path: "global.actions.hasCreatedA",
                              tag: "span",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "text-secondary bold" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$tc(
                                                "global.words.checklist",
                                                1
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "px-2" }, [_vm._v("-")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("momentLocal")(
                                    _vm.createdAt,
                                    "MMM. DD, YYYY"
                                  )
                                ) +
                                " @\n            " +
                                _vm._s(
                                  _vm._f("momentLocal")(_vm.createdAt, "LT")
                                ) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.latestUpdate
                            ? [
                                _c("span", { staticClass: "px-2" }, [
                                  _vm._v("|"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "profile-avatar",
                                  _vm._b(
                                    {
                                      staticClass:
                                        "client-profile-owner-avatar mr-2",
                                      attrs: {
                                        "avatar-options": { inline: true },
                                      },
                                    },
                                    "profile-avatar",
                                    _vm.latestUpdate.user,
                                    false
                                  )
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "mr-1" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$options.filters.nameFormat(
                                          _vm.latestUpdate.user.givenName,
                                          _vm.latestUpdate.user.familyName
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("global.words.updated")) +
                                      "\n              "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "text-secondary bold" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$tc("global.words.checklist", 1)
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "px-2" }, [
                                  _vm._v("-"),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm._f("momentLocal")(
                                          _vm.latestUpdate.timestamp,
                                          "MMM. DD, YYYY"
                                        )
                                      ) +
                                      " @\n              " +
                                      _vm._s(
                                        _vm._f("momentLocal")(
                                          _vm.latestUpdate.timestamp,
                                          "LT"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "right",
                  fn: function () {
                    return [
                      _c(
                        "b-col",
                        {
                          staticClass:
                            "d-flex flex-row align-items-center justify-content-end",
                          attrs: { col: "" },
                        },
                        [
                          _c("div", { staticClass: "dropdown ml-3" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "grey-text text-darken-4 clickable vertical-center",
                                attrs: { "data-toggle": "dropdown" },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("more_vert"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-menu dropdown-menu-right",
                              },
                              [
                                !_vm.editingTitle
                                  ? _c("div", [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "clickable dropdown-item text-primary",
                                          on: {
                                            click: _vm.handleEditChecklist,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "client-profile.actions.editChecklist"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "dropdown-divider",
                                      }),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "inline-prompt",
                                      {
                                        attrs: {
                                          placement: "left",
                                          "confirmation-text": _vm.$t(
                                            "client-profile.messages.deleteConfirmation",
                                            {
                                              item: _vm.$tc(
                                                "global.words.checklist",
                                                1
                                              ),
                                            }
                                          ),
                                        },
                                        on: { accept: _vm.handleDelete },
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "clickable dropdown-item text-danger btn-danger delete-checklist",
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "client-profile.actions.deleteChecklist"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }